<div class="row-details search-item clickable"
  (click)="rowClicked($event, searchResult)">
  @if (searchResult.statusText) {
    <div class="item-status"
      >
      <div class="highlighting"
      [ngClass]="searchResult.statusClass">{{searchResult.statusText}}</div>
    </div>
  }
  @if (searchResult.statusKey) {
    <div class="item-status"
      >
      <div class="highlighting"
      [ngClass]="searchResult.statusClass">{{searchResult.statusKey | translate}}</div>
    </div>
  }
  <div class="item-description"
    >
    @switch (searchResult.category) {
      @case ('back-user') {
        <aa-search-result-back-auth-user
          [item]="searchResult">
        </aa-search-result-back-auth-user>
      }
      @case ('back-entity') {
        <aa-search-result-back-auth-entity
          [item]="searchResult">
        </aa-search-result-back-auth-entity>
      }
      @case ('bckp-job') {
        <aa-search-result-bckp-job
        [item]="searchResult"></aa-search-result-bckp-job>
      }
      @case ('bckp-server') {
        <aa-search-result-bckp-server
          [item]="searchResult">
        </aa-search-result-bckp-server>
      }
      @case ('bckp-policy') {
        <aa-search-result-bckp-policy
          [item]="searchResult">
        </aa-search-result-bckp-policy>
      }
      @case ('comp-instance') {
        <aa-search-result-comp-instance
          [item]="searchResult">
        </aa-search-result-comp-instance>
      }
      @case ('its2-request') {
        <aa-search-result-its2-request
          [item]="searchResult">
        </aa-search-result-its2-request>
      }
    }
  </div>
</div>
